module.exports = __webpack_public_path__ + "img/bg_patrol_04.766d0518.jpg";